import React from "react";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    visualize,
    getCountries
} from "../../api/api";
import {Button, Modal, Table as TableAntd, Typography} from "antd";

export const CountryGroups = () => {

    return <div className={`country_groups`}>
        <TableV2
            header={<div>
                <Typography.Title level={3}>Country Groups</Typography.Title>
            </div>}
            fetchConfig={async (schema) => {
                return await getFeConfig('country_groups')
            }}
            customRenderer={{
                countries: (value, row)=>{
                    return [
                        <Button key={'btn'} onClick={async () =>{
                            const {data: {rows}} =  await getCountries(row)

                            Modal.info({
                                title: `Countries`,
                                content: <React.Fragment>
                                    <TableAntd dataSource={rows} size={'small'}>
                                        <TableAntd.Column title={"Country Code"} dataIndex={"country_code"}/>
                                        <TableAntd.Column title={"Country Group"} dataIndex={"name"}/>
                                    </TableAntd>
                                </React.Fragment>,

                                okType: "ghost",
                                okText: "Close",
                                maskClosable: true,
                                closable: true,
                                keyboard: true,
                                bodyStyle: {overflowX: 'scroll', overflowY: 'scroll', width: 'fit-content', height: '60vh', maxWidth: '75vw'},
                                width: 'fit-content'
                            })
                        }}>
                            View
                        </Button>

                    ]
                }
            }}
            fetchData={async () => {
                const {data: {rows}}  = await visualize("country_groups")
                return {data: {rows: rows, statusCode: 200}}
            }}
            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
        >
        </TableV2>
    </div>

}
